import { GetAllDto } from "../Shared/dto/get-all-dto"

export const ApiUrls = {
    LOGIN: "auth/login",
    REGISTRATION: "auth/registration",
    PROJECT_POST: "project",
    SAVE_FINANCIAL_YEAR: "project/savefinancialyear",
    PRODUCT_GET: "product",
    PRODUCT_GET_BY_ID: (productId: number) => "product/" + productId,
    PRODUCT_POST: "product",
    PRODUCT_PUT: (productId: number) => "product/" + productId,
    PRODUCT_DELETE: (productId: number) => "product/" + productId,
    GET_CONTACTS_FOR_MODAL: "contact/modal",
    GET_CONTACTS: "contact",
    GET_BY_ID_CONTACTS: (contactId: number) => "contact/" + contactId,
    CONTACTS_PUT: (contactId: number) => "contact/" + contactId,
    CONTACT_POST: "contact",
    CONTACT_GET_ID_POST: "contact/create",
    ADD_ESTIMATE_POST: "estimate",
    GET_ESTIMATE: "estimate",
    GET_ESTIMATE_NO: "estimate/getAutoIncrementNumber",
    GET_ESTIMATE_BY_ID: (estimateId: number) => "estimate/" + estimateId,
    ESTIMATE_PUT: (estimateId: number) => "estimate/" + estimateId,
    PROJECT_FLOOR_FLAT: "project",
    PROJECT_FLOOR_FLAT_BY_TYPE: (propertyTypeId: number) => `project/${propertyTypeId}`,
    USER_PROJECTS: "project/userprojects",
    CHANGE_PROJECT: (projectId: number) => `project/changeproject/${projectId}`,
    PROJECT_TOWER_GET: (propertyId: number) => `project/towers/${propertyId}`,
    PROJECT_PROPERTIES: "project/properties",
    FINANCIAL_YEAR: "project/financialyear",
    PROJECT_FLOOR_GET: (towerId: number) => "project/floors/" + towerId,
    PROJECT_FLAT_GET: (floorId: number, unsoled?: boolean) => "project/flats/" + floorId + (unsoled ? "/true" : ""),
    SALES_POST: "sales",
    SALES_GET: "sales",
    SALES_INVOICE_NO: "sales/getAutoIncrementNumber",
    SALES_DELETE: (salesId: number) => "sales/" + salesId,
    SALES_GET_BY_ID: (salesId: number) => "sales/" + salesId,
    SALES_GET_BY_FLATID: (flatId: number) => "sales/getByFlatId/" + flatId,
    SALE_PUT: (salesId: number) => "sales/" + salesId,
    PURCHASE_GET: "purchase",
    PURCHASE_POST: "purchase",
    LEADS_POST: "lead",
    LEADS_GET: "lead",
    LEADS_BY_ID: (leadsId: number) => "lead/" + leadsId,
    LEADS_PUT: (leadsId: number) => "lead/" + leadsId,
    PURCHASE_BY_ID: (purchaseId: number) => "purchase/" + purchaseId,
    PURCHASE_PUT: (purchaseId: number) => "purchase/" + purchaseId,
    PURCHASE_REMOVE_ATTACHMENT: (id: number) => "purchase/removeattachment/" + id,
    ACTIVITY_TYPE_GET: "activity-type",
    ACTIVITY_TYPE_POST: "activity-type",
    TASK_POST: "task",
    TASK_GET: "task",
    TASK_PUT: (taskId: number) => "task/" + taskId,
    TASK_GET_BY_ID: (taskId: number) => "task/" + taskId,
    ACTIVITY_POST: "activity",
    ACTIVITY_GET: "activity",
    ACTIVITY_BY_ID: (activityId: number) => "activity/" + activityId,
    ACTIVITY_PUT: (activityId: number) => "activity/" + activityId,
    PAYMENT_POST: "payment",
    PAYMENT_GET: "payment",
    PAYMENT_RECEIPTNO: "payment/getAutoIncrementNumber",
    PAYMENT_BY_ID: (paymentId: number) => "payment/" + paymentId,
    PAYMENT_PUT: (paymentId: number) => "payment/" + paymentId,
    PAYMENT_DELETE: (paymentId: number) => "payment/" + paymentId,
    PAYMENT_RECEIVABLE_GET: "payment/receivable",
    EXPANSE_GET: "expanse",
    EXPANSE_POST: "expanse",
    EXPANSE_REMOVE_ATTACHMENT: (id: number) => "expanse/removeattachment/" + id,
    EXPANSE_BILLNO: "expanse/getAutoIncrementNumber",
    EXPANSE_BY_ID: (expanseId: number) => "expanse/" + expanseId,
    EXPANSE_PUT: (expanseId: number) => "expanse/" + expanseId,
    EXPANSE_DELETE: (expanseId: number) => "expanse/" + expanseId,
    EXPANSE_TYPE_GET: "expanse-type",
    EXPANSE_TYPE_BY_ID: (expanseTypeId: number) => "expanse-type/" + expanseTypeId,
    EXPANSE_TYPE_POST: "expanse-type",
    EXPANSE_TYPE_PUT: (expanseTypeId: number) => "expanse-type/" + expanseTypeId,
    EXPANSE_TYPE_DELETE: (expanseTypeId: number) => "expanse-type/" + expanseTypeId,

    DASHBOARD_GET: (fromDate: string, toDate: string) => `dashboard?fromDate=${fromDate}&toDate=${toDate}`,
    USER_POST: "user",
    USER_GET: "user",
    APPROVE_USER_GET: "user/approveUsers",
    PROJECT_USER_GET: "user/projectUsers",
    CHANGE_PASSWORD: "user/changepassword",
    DECLINE_USER_GET: (id: number) => `user/declineUser/${id}`,
    USER_BY_ID: (entityId: number) => "user/" + entityId,
    USER_PUT: (entityId: number) => "user/" + entityId,
    USER_DELETE: (entityId: number) => "user/" + entityId,
    ROLE_POST: "roles-permission",
    ROLE_GET: "roles-permission",
    ROLE_BY_ID: (entityId: number) => "roles-permission/" + entityId,
    ROLE_PUT: (entityId: number) => "roles-permission/" + entityId,
    ROLE_DELETE: (entityId: number) => "roles-permission/" + entityId,
    PROJECT_REQUEST_GET: "project-request",
    PROJECT_REQUEST_POST: "project-request",
    PROJECT_REQUEST_DELETE: (id: number) => `project-request/${id}`,
    FLATWISE_REPORT: (flatId?: number| null) => flatId ? `report/flatwisedata/${flatId}` : `report/flatwisedata`,
}

export const BindQuery = (url: string, getAllDto: GetAllDto) => {
    return `${url}?recordsPerPage=${getAllDto.recordsPerPage}` +
        `&pageNumber=${getAllDto.pageNumber}` +
        `&sortBy=${getAllDto.sortBy}` +
        `&sortOrder=${getAllDto.sortOrder}` +
        (getAllDto.searchQuery ? `&searchQuery=${getAllDto.searchQuery}` : ``) +
        (getAllDto.contactId ? `&contactId=${getAllDto.contactId}` : ``)
}